import { Box, useMultiStyleConfig, VStack } from '@chakra-ui/react';
import React from 'react';

import Button from '../Button';

interface ContactActionBoxProps {
  contact: {
    content: React.ReactElement;
  };
  action: {
    content: React.ReactElement;
    label: string;
    href: string;
  };
}

const ContactActionBox: React.FC<ContactActionBoxProps> = ({
  contact,
  action,
}) => {
  const Styles = useMultiStyleConfig('ContactActionBox', {});
  return (
    <VStack sx={Styles.container} spacing={0}>
      <Box sx={Styles.contactSection}>{contact.content}</Box>
      <Box sx={Styles.actionSection}>
        <Box sx={Styles.actionText}>{action.content}</Box>

        <Button
          sx={Styles.action}
          variant="primary"
          colorScheme="white"
          href={action.href}
        >
          {action.label}
        </Button>
      </Box>
    </VStack>
  );
};

export default ContactActionBox;
